




































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import BaseServiceMixin from "../mixins/base.service.mixin";
import { Role } from "@/common/enum";
import eventBus from "../common/bus";
import IntegrationModel, { IntegrationViewModel } from "../models/IntegrationModel";
import IntegrationService from "../services/integration.service";
import Shared from "../common/shared";
import copy from "copy-to-clipboard";
import APIKeyModel, { ViewAPIKeyModel } from "../models/APIKeyModel";

@Component({
  components: {
    ValidationObserver,
  },
})
export default class Integrations extends Mixins(BaseServiceMixin) {
  private integrationService!: IntegrationService;
  private role = Role;
  private integrations: IntegrationModel[] = [];
  private apiKeys: APIKeyModel[] = [];
  private apiKeyList: ViewAPIKeyModel[] = [];
  private showModel = false;

  private get companyIntegrations(): number[] {
    return this.vuexStore.company ? this.vuexStore.company.integrations || [] : [];
  }

  private get companyAPIKey(): string {
    return this.vuexStore.companyAPIKey || "";
  }

  private get integrationList(): IntegrationViewModel[] {
    return this.integrations.map((integration: IntegrationModel) => {
      return {
        ...integration,
        isActive: this.companyIntegrations.includes(integration.id),
      };
    });
  }

  public created() {
    this.integrationService = new IntegrationService(this.axiosInstance);
  }

  private async mounted() {
    await this.getIntegrations();

    if (this.companyIntegrations.length) {
      await this.getApiKeys();
    }

    if (this.companyAPIKey !== "") {
      setTimeout(() => {
        this.showModel = true;
      }, 1000);
    }
  }

  private async getIntegrations() {
    eventBus.$emit("loading", true);
    try {
      const integrations = await this.integrationService.getIntegrations();
      if (integrations && integrations.length) {
        this.integrations = integrations;
      }
    } catch (error) {
      // Handle Error
    } finally {
      eventBus.$emit("loading", false);
    }
  }

  private async selectIntegration(integrationId: number) {
    eventBus.$emit("loading", true);
    try {
      const redirectUrl: string = await this.integrationService.authorizeIntegration(integrationId);
      localStorage.removeItem(Shared.localStorageKeys.INTEGRATION_ID);
      localStorage.setItem(Shared.localStorageKeys.INTEGRATION_ID, integrationId.toString());
      if (redirectUrl) {
        // window.location.assign(redirectUrl);
        window.location.href = redirectUrl;
      }
    } catch (error) {
      // Handle Error
    } finally {
      eventBus.$emit("loading", false);
    }
  }

  private async integrationConfirmation(integrationId: number) {
    this.$buefy.dialog.confirm({
      title: "Disable Integration",
      message: `Are you sure you want to disable this integration?`,
      confirmText: "Disable",
      type: "is-danger",
      onConfirm: () => {
        this.disableIntegration(integrationId);
      },
    });
  }

  private async disableIntegration(integrationId: number) {
    eventBus.$emit("loading", true);
    try {
      await this.integrationService.disableIntegration(integrationId);
      eventBus.$emit("refresh-company");
    } catch (error) {
      // Handle Error
    } finally {
      eventBus.$emit("loading", false);
    }
  }

  private async getApiKeys() {
    eventBus.$emit("loading", true);
    try {
      this.apiKeys = await this.integrationService.getApiKeys();
      this.apiKeys = this.apiKeys.filter((key: APIKeyModel) => key.id === 1);
      this.apiKeyList = this.apiKeys.map((key: APIKeyModel) => {
        return {
          ...key,
          token: "",
          isRefreshed: false,
          refreshingToken: false,
        };
      });
    } catch (error) {
      // Handle Error
    } finally {
      eventBus.$emit("loading", false);
    }
  }

  private async refreshApiKey(key: ViewAPIKeyModel) {
    key.refreshingToken = true;
    try {
      const token = await this.integrationService.refreshApiKey(key.id);
      key.token = token;
      key.isRefreshed = true;
    } catch (error) {
      // Handle Error
    } finally {
      key.refreshingToken = false;
    }
  }

  private async copyToClipboard(key: ViewAPIKeyModel) {
    copy(key.token);
    Shared.showToastMessage("Key copied to clipboard", "is-success");
    key.isRefreshed = false;
  }

  @Watch("showModel")
  private onModelClose() {
    if (!this.showModel) {
      this.vuexStore.setCompanyAPIKey("");
    }
  }

  @Watch("companyIntegrations")
  private async refreshApiKeys() {
    await this.getApiKeys();
  }

  private copyCompanyKeyToClipboard() {
    copy(this.vuexStore.companyAPIKey);
    this.showModel = false;
    Shared.showToastMessage("Key copied to clipboard", "is-success");
    this.vuexStore.setCompanyAPIKey("");
  }
}
